export default (function (obj, key) {
  return obj.hasOwnProperty(key);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/has.js
// module id = 29
// module chunks = 0